<template>
    <div class="catalog-aside-menu">
        <a v-for="item in result.items" :href="item.link" class="catalog-aside-menu__item">
            <span class="catalog-aside-menu__text" :class="{'catalog-aside-menu__text_active': item.current}">
                {{item.text}}
            </span>
            <span class="catalog-aside-menu__count">{{item.count}}</span>
        </a>
    </div>
</template>

<script>
    export default {
        name: 'catalog-aside-menu',
        props: {
            result: {
                type: Object,
                default: () => ({
                    items: [
                        {
                            text: 'всі товари',
                            count: '691',
                            current: true,
                            link: 'javascript: void(0)',
                        },
                        {
                            text: 'Підвіски',
                            count: '470',
                            current: false,
                            link: 'javascript: void(0)'
                        },
                        {
                            text: 'Кольє',
                            count: '221',
                            current: false,
                            link: 'javascript: void(0)'
                        }
                    ]
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .catalog-aside-menu{
        display: flex;
        flex-direction: column;
        background-color: #fff;
        padding: 0 14px;
        color: var(--text-colour-primary);
        @include point-lg{
            padding: 32px 32px 0;
        }
        &__item{
            padding-bottom: 16px;
            border-bottom: 1px solid #DFDFDF;
            text-transform: uppercase;
            font-weight: 500;
            font-size: rem(16);
            line-height: 115%;
            letter-spacing: 0.08em;
            margin-top: 16px;
            @include point-lg{
                &:first-child{
                    margin-top: 0;
                }
            }
        }
        &__text{
            &_active{
                color: var(--text-colour-secondary);
            }
        }
        &__count{
            color: #757575;
        }
    }
</style>